module.exports = [
	{
		"country": "Afghanistan",
		"people": 90845,
		"War": 1,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 1,
		"Terrorism": 1
	},
	{
		"country": "Albania",
		"people": 52755,
		"War": 0,
		"Corruption": 0,
		"freedom": 0,
		"Unemployment": 1,
		"Terrorism": 0
	},
	{
		"country": "Bangladesh",
		"people": 11305,
		"War": 0,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 0,
		"Terrorism": 1
	},
	{
		"country": "Eritrea",
		"people": 33730,
		"War": 0,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 1,
		"Terrorism": 0
	},
	{
		"country": "Gambia",
		"people": 9205,
		"War": 0,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 1,
		"Terrorism": 1
	},
	{
		"country": "Georgia",
		"people": 5615,
		"War": 0,
		"Corruption": 1,
		"freedom": 0,
		"Unemployment": 1,
		"Terrorism": 0
	},
	{
		"country": "Iran",
		"people": 10125,
		"War": 0,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 1,
		"Terrorism": 1
	},
	{
		"country": "Iraq",
		"people": 62075,
		"War": 1,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 1,
		"Terrorism": 1
	},
	{
		"country": "Kosovo",
		"people": 68005,
		"War": 0,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 1,
		"Terrorism": 0
	},
	{
		"country": "Macedonia",
		"people": 12850,
		"War": 0,
		"Corruption": 1,
		"freedom": 0,
		"Unemployment": 1,
		"Terrorism": 0
	},
	{
		"country": "Mali",
		"people": 5415,
		"War": 0,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 1,
		"Terrorism": 1
	},
	{
		"country": "Nigeria",
		"people": 19345,
		"War": 1,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 1,
		"Terrorism": 1
	},
	{
		"country": "Pakistan",
		"people": 31865,
		"War": 1,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 0,
		"Terrorism": 1
	},
	{
		"country": "Russia",
		"people": 14650,
		"War": 0,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 0,
		"Terrorism": 1
	},
	{
		"country": "Serbia",
		"people": 24845,
		"War": 0,
		"Corruption": 1,
		"freedom": 0,
		"Unemployment": 1,
		"Terrorism": 0
	},
	{
		"country": "Somalia",
		"people": 16425,
		"War": 1,
		"Corruption": 0,
		"freedom": 1,
		"Unemployment": 0,
		"Terrorism": 1
	},
	{
		"country": "Syria",
		"people": 189605,
		"War": 1,
		"Corruption": 1,
		"freedom": 1,
		"Unemployment": 1,
		"Terrorism": 1
	},
	{
		"country": "Ukraine",
		"people": 15065,
		"War": 1,
		"Corruption": 0,
		"freedom": 0,
		"Unemployment": 1,
		"Terrorism": 1
	}
];


//////////////////
// WEBPACK FOOTER
// ./data.json
// module id = 243
// module chunks = 0